import { Component, Input, OnInit } from '@angular/core';
import { EMailAudit, EMailInbox } from '../../../classes';

@Component({
  selector: 'app-mail-list-entry',
  templateUrl: './mail-list-entry.component.html',
  styleUrls: ['./mail-list-entry.component.css']
})
export class MailListEntryComponent implements OnInit {

  public mailSetted: boolean = false;
  public type: string = null;

  private _currentMail = null;

  @Input() set currentMail(mail: EMailAudit){
    if(mail){
      this.mailSetted = true;
      this._currentMail = mail;
      switch(mail.inbox){

        case EMailInbox.Assignment:
          this.type = "Auftrag im Postfach";
          break;

        case EMailInbox.Incident:
          this.type = "Ticket im Postfach";
          break;

        default:
          this.type = "Unbekannter Mailtyp im Postfach";
          break;

      }
    }
  }

  get currentMail(): EMailAudit {
    return this._currentMail;
  }

  constructor() {
    
  }

  ngOnInit() {
  }

}
